import React from "react"
import { Button, Flex, Heading, Text } from "@chakra-ui/react"
import { graphql, useStaticQuery } from "gatsby"
type Props = {
  onClose: () => void
}
const ReviewAddFormComplete: React.FC<Props> = ({ onClose }) => {
  const { locales } = useStaticQuery<GatsbyTypes.ReviewSectionFormCompleteQuery>(graphql`
    query ReviewSectionFormComplete {
      locales: sanityTemplateProduct {
        additionReviewDrawSubmitTitle
        reviewDrawSubmitBody
      }
    }
  `)
  return (
    <Flex p={4} width={"100%"} textAlign="center" alignItems={"center"} flexDirection={"column"}>
      <Flex width={{ base: "min-content", sm: 496 }} flexDirection={"column"}>
        <Heading
          size="lg"
          mb={2}
          textTransform="none"
          color="grey.text"
          fontSize="32px"
          fontStyle="normal"
          fontWeight={500}
          lineHeight="32px"
          whiteSpace={"nowrap"}
        >
          {locales?.additionReviewDrawSubmitTitle}
        </Heading>
        <Text color="grey.text" fontSize="14px" fontStyle="normal" fontWeight={400} lineHeight="24px" letterSpacing="0.75px">
          {locales?.additionReviewDrawSubmitBody}
        </Text>
        <Button mt={4} pt={4} pb={3} px={3} colorScheme="teal" onClick={onClose} variant={"pdpAddToCart"}>
          Close
        </Button>
      </Flex>
    </Flex>
  )
}

export default ReviewAddFormComplete
